// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#V-ABC32CEF-AA97-42DD-A169-60C9A05E9F5B .table-filter-icon {\n  font-size: xx-large;\n}\n", "",{"version":3,"sources":["webpack://src/Warehouse/warehousePlacementManipulation/warehousePlacementManipulation.less"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR","sourcesContent":["#V-ABC32CEF-AA97-42DD-A169-60C9A05E9F5B{\n    & .table-filter-icon{\n        font-size: xx-large;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
